import React, { FC, ReactNode } from "react";
import classNames from "classnames";
import { IconChevronDownGlyph } from "../../../videos/selectedVideoCardV2/panels";

/**
 * The disclosure row the page block's Score history and Markup rows share.
 *
 *   <DisclosureRow label="Score history" count={5} open={open} onToggle={toggle} controls={bodyId} />
 */

interface DisclosureRowProps {
  label: string;
  /** --text-2 after the label ("Score history 5"). Omitted while unknown. */
  count?: number | null;
  /** Beside the label: the Markup row's eligibility line. */
  extra?: ReactNode;
  open: boolean;
  onToggle: () => void;
  /** The body's id. */
  controls: string;
}

/**
 * A 44px row with a top rule that opens the body under it (handoff README:180,
 * :324): 13px, hover --accent-text, the chevron turns 180° in 220ms and holds
 * still under reduced motion. `aria-expanded` + `aria-controls`.
 */
export const DisclosureRow: FC<DisclosureRowProps> = ({ label, count, extra, open, onToggle, controls }) => (
  <button
    type="button"
    aria-expanded={open}
    aria-controls={controls}
    onClick={onToggle}
    className="w-full min-h-11 flex flex-wrap items-center gap-x-3 gap-y-1.5 py-2 border-t border-border-token bg-transparent text-left text-text-1 hover:text-accent-text transition-colors"
    style={{ fontSize: 13 }}
  >
    <span className="inline-flex items-center gap-2">
      {label}
      {count != null && <span className="text-text-2 tabular-nums">{count}</span>}
    </span>
    {extra}
    <span className="flex-1" />
    <span
      className={classNames(
        "inline-flex shrink-0 text-text-2 transition-transform duration-[220ms] motion-reduce:transition-none",
        open && "rotate-180",
      )}
    >
      <IconChevronDownGlyph size={16} strokeWidth={2} />
    </span>
  </button>
);
